<template>
  <div class="full-width-image" ref="imageContainer">
    <!-- Separador con ancho fijo de 180px -->
    <div class="separator-wrapper" ref="separatorRef">
      <img 
        src="@/assets/ssss.png" 
        alt="Separator" 
        class="separator-image" 
      />
    </div>

    <!-- Contenido Principal: Foto y Mensaje de Bienvenida/Invitación -->
    <div class="content-section" ref="contentSection">
      <div class="image-wrapper" ref="photoRef">
        <img 
          src="@/assets/descarga (24).jpeg" 
          alt="Quinceañera" 
          class="quince-photo"
        />
        <div class="photo-overlay"></div>
      </div>

      <div class="message-container" ref="messageRef">
        <h2 class="welcome-title">I look forward to celebrating this special day with you all!!</h2>
        <p class="welcome-text">
        
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { ref, onMounted } from 'vue';
import { gsap } from 'gsap';

export default {
  name: 'FullWidthImage',
  setup() {
    const imageContainer = ref(null);
    const separatorRef = ref(null);
    const photoRef = ref(null);
    const messageRef = ref(null);

    const animateIn = () => {
      gsap.timeline()
        .fromTo(
          imageContainer.value,
          { opacity: 0, y: 30 },
          { opacity: 1, y: 0, duration: 0.8, ease: 'power3.out' }
        )
        .fromTo(
          separatorRef.value,
          { opacity: 0, scale: 0.9, y: 20 },
          { opacity: 1, scale: 1, y: 0, duration: 1, ease: 'power2.out' },
          '-=0.4'
        )
        .fromTo(
          photoRef.value,
          { opacity: 0, y: 40, scale: 0.96 },
          { opacity: 1, y: 0, scale: 1, duration: 1.1, ease: 'power2.out' },
          '-=0.6'
        )
        .fromTo(
          messageRef.value,
          { opacity: 0, y: 25 },
          { opacity: 1, y: 0, duration: 0.9, ease: 'power2.out' },
          '-=0.7'
        );
    };

    onMounted(() => {
      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            animateIn();
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.2 });

      if (imageContainer.value) observer.observe(imageContainer.value);
    });

    return { 
      imageContainer, 
      separatorRef, 
      photoRef, 
      messageRef 
    };
  }
};
</script>

<style scoped>
.full-width-image {
  width: 100%;
  position: relative;
  overflow: hidden;
  opacity: 0;
  background-color: #000000;
}

/* Separador ajustado a 180px */
.separator-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 0 15px 0;
}

.separator-image {
  width: 180px;
  max-width: 100%;
  height: auto;
  display: block;
  object-fit: contain;
}

/* Sección de Contenido */
.content-section {
  background-color: #000000;
  padding: 10px 20px 60px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

/* Tratamiento para destacar la foto sobre fondo negro */
.image-wrapper {
  position: relative;
  max-width: 480px;
  width: 100%;
  margin-bottom: 30px;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(255, 255, 255, 0.08), 0 0 15px rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.12);
}

.quince-photo {
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
}

.photo-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 65%, rgba(0, 0, 0, 0.6) 100%);
  pointer-events: none;
}

/* Textos de Bienvenida / Invitación */
.message-container {
  max-width: 550px;
  color: #ffffff;
}

.welcome-title {
  font-size: 2.2rem;
  font-weight: 300;
  letter-spacing: 2px;
  margin-bottom: 15px;
 font-family: 'Playfair Display', serif;
  font-size: 44px;
  letter-spacing: 2px;
  color: #fffbfb;  font-weight: 400;
  font-size: 59px;
  color:#e6b1c4;}

.welcome-text {
   font-family: 'quote', serif;
  color: #fff;
  font-size: 18px;
  line-height: 1.6;
  color: #cccccc;
  font-weight: 300;
  margin: 0;
}

@media (max-width: 768px) {
  .separator-image {
    width: 150px; /* Tamaño responsivo opcional en móviles */
  }

  .welcome-title {
    font-size: 1.35rem;
  }
  .welcome-text {
    font-size: 0.95rem;
  }
}
</style>